module.exports = __webpack_public_path__ + "img/Exotel.c2175f1a.png";